import { createContext } from 'react';
import { createHost } from '@react-spring/animated';
import { DEFAULT_THEME, LIGHT_THEME, UPLIFT_THEME, DEFAULT_COMPONENTS, DEFAULT_THEME_NAME } from '../constants.js';

const host = createHost({
  // eslint-disable-next-line id-length
  g: 'G'
});
const PolarisVizContext = /*#__PURE__*/createContext({
  themes: {
    Default: DEFAULT_THEME,
    Light: LIGHT_THEME,
    Uplift: UPLIFT_THEME
  },
  components: { ...DEFAULT_COMPONENTS
  },
  animated: host.animated,
  defaultTheme: DEFAULT_THEME_NAME
});

export { PolarisVizContext };
